module.exports = __webpack_public_path__ + "4-79.jpg?e78c07243d5b4d76a945c2913ccc9eb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-79.jpg
// module id = 160
// module chunks = 0